import template from "./pTermsOfUse.html";
import moment   from "moment";

export function pTermsOfUseDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pTermsOfUseController,
    controllerAs: 'pTermsOfUse',
    bindToController: true
  };

  return directive;
}

class pTermsOfUseController {
  constructor(Auth) {
    'ngInject';

    this.Auth = Auth;
    this.state = 'loading';

    this.init();
  }

  init() {
    this.state = 'loading';
    this.Auth.getLatestTermsOfUse().then(
      ({data}) => {
        this.state = 'loaded';
        this.terms = {
          ...data,
          createdAt: moment(data.createdAt).format('DD-MM-YYYY')
        };

        this.contentToDisplay = this.terms.content.english;
        this.version = this.terms.version;
        this.createdAt = this.terms.createdAt;
      },
      error => {
        this.state = error;
        this.contentToDisplay = "ERROR";
      }
    );
  }

  switchLanguage(language) {
    this.language = language;
    this.contentToDisplay = this.terms.content[language];
  }
}
